module.exports = __webpack_public_path__ + "main/assets/public/email/soundcloud-logo.554949922e5bb607.png";